// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS Systems Manager Quick Setup (SSM-QUICKSETUP)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awssystemsmanagerquicksetup.html
 *
 * 2025-02-24T21:49:57.465Z
 */
export enum AwsSsmQuicksetupActions {
  /**
   * Grants permission to create a Quick Setup configuration manager resource
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_CreateConfigurationManager.html
   */
  CreateConfigurationManager = 'ssm-quicksetup:CreateConfigurationManager',
  /**
   * Grants permission to delete a configuration manager
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_DeleteConfigurationManager.html
   */
  DeleteConfigurationManager = 'ssm-quicksetup:DeleteConfigurationManager',
  /**
   * Grants permission to get Quick Setup configuration
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_GetConfiguration.html
   */
  GetConfiguration = 'ssm-quicksetup:GetConfiguration',
  /**
   * Grants permission to get a configuration manager
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_GetConfigurationManager.html
   */
  GetConfigurationManager = 'ssm-quicksetup:GetConfigurationManager',
  /**
   * Grants permission to get settings configured for Quick Setup in the requesting
   * AWS account and AWS Region
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_GetServiceSettings.html
   */
  GetServiceSettings = 'ssm-quicksetup:GetServiceSettings',
  /**
   * Grants permission to list Quick Setup configuration managers
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_ListConfigurationManagers.html
   */
  ListConfigurationManagers = 'ssm-quicksetup:ListConfigurationManagers',
  /**
   * Grants permission to list Quick Setup configurations
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_ListConfigurations.html
   */
  ListConfigurations = 'ssm-quicksetup:ListConfigurations',
  /**
   * Grants permission to list the available Quick Setup types
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_ListQuickSetupTypes.html
   */
  ListQuickSetupTypes = 'ssm-quicksetup:ListQuickSetupTypes',
  /**
   * Grants permission to list tags assigned to the resource
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_ListTagsForResource.html
   */
  ListTagsForResource = 'ssm-quicksetup:ListTagsForResource',
  /**
   * Grants permission to Assign key-value pairs of metadata to AWS resources
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_TagResource.html
   */
  TagResource = 'ssm-quicksetup:TagResource',
  /**
   * Grants permission to remove tags from the specified resource
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_UntagResource.html
   */
  UntagResource = 'ssm-quicksetup:UntagResource',
  /**
   * Grants permission to update a Quick Setup configuration definition
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_UpdateConfigurationDefinition.html
   */
  UpdateConfigurationDefinition = 'ssm-quicksetup:UpdateConfigurationDefinition',
  /**
   * Grants permission to update a Quick Setup configuration manager
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_UpdateConfigurationManager.html
   */
  UpdateConfigurationManager = 'ssm-quicksetup:UpdateConfigurationManager',
  /**
   * Grants permission to update settings configured for Quick Setup
   *
   * See https://docs.aws.amazon.com/quick-setup/latest/APIReference/API_UpdateServiceSettings.html
   */
  UpdateServiceSettings = 'ssm-quicksetup:UpdateServiceSettings',
}
